import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ComponentsModule} from "./components/components.module";
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {ModalModule} from 'ngb-modal';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {ComponentLoaderFactory} from "ngx-bootstrap/component-loader";
import {PositioningService} from "ngx-bootstrap/positioning";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ToastrModule} from "ngx-toastr";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoaderService} from "./services/loader.service";
import {LoaderInterceptor} from "./interceptors/loader.interceptor";
import {initializer} from "./utils/app-init";
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {AppAuthGuard} from "./app.authguard";
import {MyStorageService} from "./services/my-storage.service";
import {Utilities} from "./utils/utilities";
import {Constants} from "./utils/constants";
import {HomeComponent} from './pages/home/home.component';
import {AccessDeniedComponent} from './pages/access-denied/access-denied.component';
import {NgStompSockModule} from "@oril/ng-stomp-sock";
import {environment} from "../environments/environment";
import {HellpositoryModule} from "hellpository";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AccessDeniedComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    ComponentsModule,
    HttpClientModule,
    KeycloakAngularModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient, MyStorageService]
      }
    }),
    NgStompSockModule.config({
      url: environment.wsUrl
    }),

    HellpositoryModule.forRoot({
      apiUrl:environment.serviceUrl,
      errorHandler:Utilities.handleError
    })
  ],
  providers: [
    LoaderService,
    {provide: Window, useValue: window},
    {provide: APP_INITIALIZER, useFactory: initializer, deps: [KeycloakService], multi: true},
    BsModalService,
    ComponentLoaderFactory,
    PositioningService,
    BsModalRef,
    AppAuthGuard,
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true}],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function httpTranslateLoader(http: HttpClient, myStorage: MyStorageService) {
  if (!myStorage.checkKey('turnOffTranslations')) {
    return new TranslateHttpLoader(http, Utilities.getTranslateUrl(), '/' + Constants.ENVIRONMENT);
  } else {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }
}
